import React, { useState, useEffect } from "react";
import RenderWizardUI from "./RenderWizardUI";
import { useHistory } from "react-router-dom";
import ResourcesTab from "../ResourcesTab";
import * as services from "../../../store/service";
import { useDispatch, useSelector } from "react-redux";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { getFlowByName, FLOW_STEP_COMPLETED_STATUS, TAKE_YOUR_SECURITY_ASSESSMENT } from "../../../config/FlowName";
import { ApplicationState } from "../../../store";
import * as SecurityAssesmentAction from "../../../store/securityAssesmentService/actions";
import { IQuestionairesResponseData, IQuestionaires, IDetailQuestionaires, IDetailAnswerSchema } from "../../../store/securityAssesmentService/types";
import * as LoginActions from "../../../store/loginService/actions";
import * as UserServiceAction from "../../../store/userService/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import LogoContainer from "../../common/LogoContainer";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from 'react-i18next';

const SecurityAssessmentWizard = (props: any) => {
    let history = useHistory();
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    const [numberOfQuestion, setNumberOfQuestion] = useState(0);
    const [position, setposition] = useState(0);
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const [answers, setAnswers] = useState({} as any);
    const [answerList, setAnswerList] = useState([] as any[]);
    const [questionaires, setQuestionaires] = useState({} as IQuestionairesResponseData);
    const [allQuestions, setAllQuestions] = useState([] as any[]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const securityAssesmentFlow = useSelector((state: ApplicationState) => getFlowByName(state, TAKE_YOUR_SECURITY_ASSESSMENT));
    const requestSecurityAssesmentReview = (forcefullyRefresh: boolean) =>
        dispatch(SecurityAssesmentAction.actionCreators.requestAssesmentSummary(forcefullyRefresh));
    const updateSmbServiceDetails = () => dispatch(LoginActions.actionCreators.updateSmbServiceDetails());
    const getUserService = (isForceCall: boolean) => dispatch(UserServiceAction.actionCreators.requestUserService(isForceCall));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const getQuestionaires = () => {
        setIsLoading(true);
        setIsSubmitted(false);

        services.getSecurityAssessmentQuestionaires().then((data) => {
            setIsLoading(false);

            if (!data.HasError) {
                convertHTMLResponseToStandard(data);
            }
        });
    };

    const removeHtmlTags = (str: string) => {
        if (str) {
            str = str.toString();
            return str.replace(/(<([^>]+)>)/gi, "");
        }
        return "";
    };

    const parseHTML = (value: any, tagName: any) => {
        const splitedActionText = value.replace("<br />", "<br/>").split("<br/>");

        if (splitedActionText && splitedActionText.length > 0) {
            if (tagName === "title") {
                return removeHtmlTags(splitedActionText[0]);
            } else {
                return removeHtmlTags(splitedActionText[1]);
            }
        }
    };

    const convertHTMLResponseToStandard = (data: any) => {
        var questionsData: IQuestionairesResponseData = {};
        const query = new URLSearchParams(props.location.search);
        const id = query.get("parentID");

        questionsData.HasError = data.HasError;
        questionsData.ErrorText = data.ErrorText;
        questionsData.Questions = [] as IQuestionaires[];

        let questionList: IQuestionaires[] = [];
        for (let EZSQue of data.EZSQuestions) {
            let question: IQuestionaires = {};

            question.AnswerSchema = {} as IDetailQuestionaires;
            question.AnswerSchema.AnswerSchema = [] as IDetailAnswerSchema[];

            for (let cQue of EZSQue.childQuestions) {
                let detailQuestion: IDetailAnswerSchema = {};

                detailQuestion.Details = parseHTML(cQue.QuestionText, "desc");
                detailQuestion.Id = cQue.Id;
                detailQuestion.ParentID = cQue.ParentID;
                detailQuestion.Title = parseHTML(cQue.ActionText, "title");

                question.AnswerSchema.AnswerSchema?.push(detailQuestion);
            }
            question.Id = EZSQue.Id;
            question.Details = EZSQue.QuestionText.substring(EZSQue.QuestionText.search("<p>") + 3, EZSQue.QuestionText.search("</p>"));
            question.Question = EZSQue.QuestionText.substring(EZSQue.QuestionText.search('<p class="question">') + 20, EZSQue.QuestionText.length - 4);
            question.Title = EZSQue.ActionText.substring(4, EZSQue.ActionText.search("</h4>"));
            question.AnswerSchema.Question = EZSQue.AlternateText.substring(
                EZSQue.AlternateText.search('<p class="question">') + 20,
                EZSQue.AlternateText.length - 4
            );
            if (id != null) {
                if (question.Id == id) {
                    questionsData.Questions.push(question);
                }
            } else {
                questionsData.Questions.push(question);
            }

            questionList.push(question);
        }
        setAllQuestions(questionList);
        setQuestionaires(questionsData);
        setNumberOfQuestion(questionsData.Questions.length);
    };

    useEffect(() => {
        getQuestionaires();
        return () => {
            if (isSubmitted === false) {
                pingAssesment(true);
            }
        };
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const nextStep = () => {
        if (position < numberOfQuestion - 1) {
            setposition(position + 1);
        }

        submitAnswers();
    };

    const previousStep = () => {
        if (position > 0) {
            setposition(position - 1);
        }
    };

    const setAnswer = (ans: any) => {
        let key = Object.keys(ans)[0];
        answers[key] = ans[key];
        setAnswers(answers);

        let tempAns = [...answerList];
        let answerIndex = answerList?.findIndex((it) => it.position === position && it.questionId === key);
        if (answerIndex >= 0) {
            tempAns.splice(answerIndex, 1);
            setAnswerList(tempAns);
        } else {
            let answer = {
                position: position,
                questionId: key,
                answer: ans[key],
            };
            setAnswerList([...answerList, answer]);
        }
    };

    const updateDshboardGetStartedStatus = () => {
        const shouldSecurityAssesmentFlowUpdateToCompleteStatus: boolean =
            securityAssesmentFlow && securityAssesmentFlow.flowStepStatus !== FLOW_STEP_COMPLETED_STATUS ? true : false;
        if (shouldSecurityAssesmentFlowUpdateToCompleteStatus && securityAssesmentFlow) {
            completeGetStartedItem(securityAssesmentFlow.flowStepId, securityAssesmentFlow.flowName ? securityAssesmentFlow.flowName : " ");
        }
    };

    const pingAssesment = (redirect: boolean) => {
        updateDshboardGetStartedStatus();
        requestSecurityAssesmentReview(true);
        updateSmbServiceDetails();
        getUserService(true);

        if (redirect) {
            history.push("/resources/security-assessment");
        }
    };

    const changePositionAndNavigate = () => {
        if (numberOfQuestion === position + 1) {
            pingAssesment(true);
            setIsSubmitted(true);
        }
    };

    const submitAnswers = () => {
        let currentAnswers = answerList?.filter((it: any) => it.position === position);
        let response = { userAnswers: [] as any };

        currentAnswers?.forEach((it: any) => {
            let answer = {
                QuestionId: Number(it.questionId),
                Response: it.answer,
            };
            response.userAnswers.push(answer);
        });
        services.submitSecurityAssessmentUserAnswers(response).then((data) => {
            if (!data.HasError) {
                updateDshboardGetStartedStatus();
                changePositionAndNavigate();
            }
        });
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        {tLang("resourcesSection.resourcesTitleText")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="1" />

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="shield-alt" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{tLang("resourcesSection.securityAssessmentTab.securityAssessmentTitle")}</h2>
                                </div>
                            </div>
                            {isLoading ? (
                                <div className="box loading"></div>
                            ) : (
                                <div className="box-description">
                                    <RenderWizardUI
                                        key={"wizerdUI-" + position}
                                        question={questionaires?.Questions}
                                        answer={answers}
                                        position={position}
                                        currentPosition={position}
                                        setAnswer={setAnswer}
                                        numberOfQuestion={numberOfQuestion}
                                        nextCallback={nextStep}
                                        previousCallBack={previousStep}
                                        allQuestions={allQuestions}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SecurityAssessmentWizard;
